const addNumbersDialogStyle = () => ({
	buttonsWrapper: {
		display: 'flex',
		justifyContent: 'flex-end',
		margin: '90px 30px 22px 0',
	},
	addButton: {
		marginLeft: 8,
	},
	addAnyNumberInputWrapper: {
		display: 'flex',
		alignItems: 'flex-start',
		'& > span': {
			width: '100%',
		},
	},
	addNumbersDialogWrapper: {
		margin: '17px 58px auto 58px',
		maxWidth: 386,
	},
	numberTag: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	customNumber: {
		width: '118px',
		display: 'inline-block',
		marginRight: 4,
	},
	addNumberBtnWrapper: {
		paddingTop: 20,
	},
});

export default addNumbersDialogStyle;
